import React, { useState } from "react";
import { useDataLoader, LoadingRegion, order, Stack, HoverRegion, PullRight } from "@optimed/react";
import { mappingService, syncService } from "../api";
import { Button, Panel, PanelBody, toast } from "@optimed/react";
import { ValidationView } from "./ValidationView";
import { modelValidator } from "./modelValidator";
import { DoctorOptimedLabel } from "./DoctorOptimedLabel";
import { DoctorLabel } from "./DoctorLabel";
import { DoctorMapping } from "../api/models";
import { doctorMappingDialog } from "./DoctorMappingDialog";

export function DoctorsPanel() {
  const [doctors, loading, refreshDoctors] = useDataLoader(() => syncService.doctors());
  const doctorsDocplanner = order(
    doctors?.filter(x => x.docplanner) ?? [],
    x => !x.his,
    x => x.docplanner?.doctor?.name,
    x => x.docplanner?.doctor?.surname
  );
  const doctorsHis = order(
    doctors?.filter(x => !x.docplanner && x.his) ?? [],
    x => x.his?.doctor?.imie,
    x => x.his?.doctor?.nazwisko
  );
  const [othersLimit, setOthersLimit] = useState<number | undefined>(3);

  function setMapping(map: DoctorMapping) {
    if (!map.docplanner || !doctorsHis) return;

    doctorMappingDialog
      .open({
        docplannerDoctor: map.docplanner,
        hisDoctors: doctorsHis.map(x => x.his!),
      })
      .then(() => {
        toast.success("Mapowanie lekarza zostało dodane");
        refreshDoctors(true);
      });
  }

  function removeMapping(map: DoctorMapping) {
    mappingService
      .deleteDoctor({
        docplannerDoctorId: map.docplanner?.doctor?.id,
        docplannerAddressId: map.docplanner?.address?.id,
      })
      .then(() => {
        toast.success("Mapowanie lekarza zostało usunięte");
        refreshDoctors(true);
      });
  }

  return (
    <Panel>
      <PanelBody>
        <LoadingRegion promise={loading}>
          <div className="mb-3">
            <h5>Lekarze w portalu Znany Lekarz</h5>
            <div hidden={doctorsDocplanner.length > 0}>Brak lekarzy</div>
            <Stack>
              {doctorsDocplanner.map(x => (
                <HoverRegion key={x.docplanner?.key}>
                  <div>
                    <HoverRegion.WhenHover>
                      <PullRight>
                        <span>
                          {x.mappingId ? (
                            <Button size="sm" text="Usuń mapowanie" color="danger" onClick={() => removeMapping(x)} />
                          ) : (
                            <Button size="sm" text="Ustaw mapowanie" onClick={() => setMapping(x)} />
                          )}
                        </span>
                      </PullRight>
                    </HoverRegion.WhenHover>
                    <div>
                      <DoctorLabel doctor={x} />
                      <ValidationView validations={modelValidator.checkDoctorMapping(x)} />
                    </div>
                  </div>
                </HoverRegion>
              ))}
            </Stack>
          </div>
          <div>
            <h5>Lekarze niedostępni w Znanym Lekarzu</h5>
            <div hidden={doctorsHis.length > 0}>Brak lekarzy</div>
            {doctorsHis.map((x, idx) => {
              if (othersLimit && idx >= othersLimit) return null;

              return (
                <div key={x.his?.key}>
                  <DoctorOptimedLabel doctor={x.his?.doctor} />
                  <div className="small">{x.his?.unit?.nazwa}</div>
                </div>
              );
            })}
            {othersLimit && othersLimit < doctorsHis.length && (
              <Button
                size="sm"
                text={`Pokaż wszystkich ${doctorsHis.length} lekarzy`}
                onClick={() => setOthersLimit(undefined)}
              />
            )}
          </div>
        </LoadingRegion>
      </PanelBody>
    </Panel>
  );
}
